import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { SuperUserService } from '@app/auth/components/login/services/super-user.service';
import { FormModule } from '@app/shared/form';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  DEFAULT_THEME,
  NbAccordionModule,
  NbActionsModule,
  NbButtonModule,
  NbContextMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbThemeModule,
  NbUserModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import {
  BreadcrumbModule,
  FooterComponent,
  HeaderComponent,
  OneColumnLayoutComponent,
  UserActionComponent
} from './layouts';
import { ActionsFooterFilterPipe } from './layouts/actions-footer/action-footer-filter.pipe';
import { ActionsFooterComponent } from './layouts/actions-footer/actions-footer.component';
import { ActionsFooterService } from './layouts/actions-footer/actions-footer.service';
import { LoadingService } from './layouts/loading.services';
import { LayoutPageTitleComponent } from './layouts/page-title/layout-page-title.component';
import { LayoutPageTitleService } from './layouts/page-title/layout-page-title.service';

const NB_MODULES = [
  FormModule,
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbContextMenuModule,
  NbSidebarModule,
  NbSecurityModule,
  NbButtonModule,
  NbIconModule,
  NbEvaIconsModule,
  NbSpinnerModule,
  BreadcrumbModule,
  NbAccordionModule,
  TranslateModule.forChild()
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent,
  UserActionComponent,
  ActionsFooterComponent,
  LayoutPageTitleComponent
];

@NgModule({
    imports: [CommonModule, ...NB_MODULES, ...COMPONENTS, ActionsFooterFilterPipe],
    exports: [CommonModule, ...COMPONENTS],
    providers: [SuperUserService]
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        LoadingService,
        ActionsFooterService,
        LayoutPageTitleService,
        ...BreadcrumbModule.forRoot().providers,
        ...NbThemeModule.forRoot(
          {
            name: 'default'
          },
          [DEFAULT_THEME]
        ).providers
      ]
    };
  }
}
